
        var result = require("!!../../../../node_modules/css-loader/index.js??ref--17-oneOf-0-1!../../../../node_modules/postcss-loader/lib/index.js??ref--17-oneOf-0-2!../../../../node_modules/stylus-loader/index.js??ref--17-oneOf-0-3!./override.styl?inline");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    